export default [
    {
        value: "DP",
        text: "DP - Domínio público"
    },
    {
        value: "EE",
        text: "Exclusivo da(s) empresa(s) de energia elétrica"
    },
    {
        value: "EX",
        text: "Exclusivo da(s) entidade(s) executora(s)"
    },
    {
        value: "CE",
        text: "CE - Compartilhado entre empresa(s) de energia elétrica e entidades executora(s)"
    },
]